import axios from "src/utils/axios";
import { loadIsler } from 'src/utils/storage/WorkOrder';

// return the user data from the session storage
export const getUser = () => {
  const userStr = sessionStorage.getItem('user');
  if (userStr) {
    return JSON.parse(userStr);
  } else {
    setUserSessionFromLocale();
    return localStorage.getItem('user');
  }
}
export const setUserMobile = (MobileNumber) => {
  const ChangeuserStr = sessionStorage.getItem('user');
  const ChangeuserStr1 = JSON.parse(ChangeuserStr);
  ChangeuserStr1.MobileNumber = MobileNumber;

  sessionStorage.removeItem('user');
  sessionStorage.setItem('user', JSON.stringify(ChangeuserStr1));

  localStorage.removeItem('user');
  localStorage.setItem('user', JSON.stringify(ChangeuserStr1));

}
// return the token from the session storage
export const getToken = () => {
  return sessionStorage.getItem('token') || null;
}

export const getTokenWs = () => {
  return sessionStorage.getItem('tokenWs') || null;
}

export const getIpAddress = () => {
  return localStorage.getItem('IpAddress') || null;
}

export const setIpAddress = (IpAddress) => {  // T_ARTEMIS kontrolü yaparken tokensız gitmesin diye eklendi. Okta sonrası kaldırılacak.
  localStorage.setItem('IpAddress', IpAddress);
}


// remove the token and user from the session storage
export const removeUserSession = () => {
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('tokenWs');
  sessionStorage.removeItem('user');
  localStorage.removeItem('token');
  localStorage.removeItem('tokenWs');
  localStorage.removeItem('user');
  localStorage.removeItem('lastLogin');
}

// set the token and user from the session storage
export const setUserSession = (token, tokenWs, user) => {
  localStorage.setItem('token', token);
  localStorage.setItem('tokenWs', tokenWs);
  localStorage.setItem('user', JSON.stringify(user));
  localStorage.setItem('lastLogin', new Date());
  sessionStorage.setItem('token', token);
  sessionStorage.setItem('tokenWs', tokenWs);
  sessionStorage.setItem('user', JSON.stringify(user));
}

// set the token and user from the session storage
export const setSessionToken = (token, tokenWs) => {  // T_ARTEMIS kontrolü yaparken tokensız gitmesin diye eklendi. Okta sonrası kaldırılacak.
  localStorage.removeItem('user');
  localStorage.removeItem('lastLogin');
  localStorage.setItem('token', token);
  localStorage.setItem('tokenWs', tokenWs);
  sessionStorage.setItem('token', token);
  sessionStorage.setItem('tokenWs', tokenWs);
}

export const setUserSessionFromLocale = () => {
  const lastLogin = localStorage.getItem('lastLogin');
  const token = localStorage.getItem('token');
  const tokenWs = localStorage.getItem('tokenWs');
  const user = localStorage.getItem('user');
  if (lastLogin === null || token === null || user === null) {
    return false;
  }
  const now = new Date();
  const ll = new Date(lastLogin);
  if (now.getYear() === ll.getYear() && now.getMonth() === ll.getMonth() && now.getDate() === ll.getDate()) {
    sessionStorage.setItem('token', token);
    sessionStorage.setItem('tokenWs', tokenWs);
    sessionStorage.setItem('user', user);
    return true;
  }
  return false;
}



// set Language preference
export const setLanguage = lang => {
  sessionStorage.removeItem('language');
  sessionStorage.setItem('language', lang);
}

//get Language preference, if it is not set, return english as default.
export const getLanguage = () => {
  return sessionStorage.getItem('language') || 'tr';
}

export const getKoordinat = (Param) => {
  return sessionStorage.getItem(Param) || null;
}

export const setKoordinat = (Enlem, Boylam,) => {
  sessionStorage.removeItem('Enlem');
  sessionStorage.removeItem('Boylam');
  sessionStorage.setItem('Enlem', Enlem);
  sessionStorage.setItem('Boylam', Boylam);
}

export var options = {
  enableHighAccuracy: true,
  timeout: 30000,
  maximumAge: 0
};
function success(pos) {
  var crd = pos.coords;
  setKoordinat(crd.latitude, crd.longitude);
}

function error(err) {

  if (parseInt(err.code) === 3) {
    navigator.geolocation.getCurrentPosition(success, error, options);
  } else {
    var Uyari = err.code + ':' + err.message;
    Uyari = Uyari + ' Konum Bilgilerinizi Paylaşmaya İzin Verdikten Sonra Tekrar Giriş Yapınız!..';
    alert(Uyari);
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = window.location.origin;
  }

}

export function GetLocation() {
  return navigator.geolocation.getCurrentPosition(success, error, options);
}

export const publishLocation = (musteriNo = 1) => {
  try {

    const isler = loadIsler().filter(d => parseInt(d.DurumKodu) === 42);

    if (isler.length === 0) {
      return;
    }
    if (parseInt(musteriNo) !== 0 && isler.filter(i => parseInt(i.MusteriNo) === parseInt(musteriNo)).length === 0) {
      return;
    }
    navigator.geolocation.getCurrentPosition(sendLocation, (error) => {}, options);
  } catch (error) {

  }
}

export const sendLocation = (pos) => {
  return;
}

// string comparison
export const sc = (str, key) => {
  return (str || '').toString().toLocaleLowerCase('tr-TR').indexOf((key || '').toString().toLocaleLowerCase('tr-TR')) !== -1;
}

// return the plate from the session storage
export const getPlate = () => {
  return localStorage.getItem('plate') || '';
}

// update plate.
export const setPlate = (p) => {
  localStorage.removeItem('plate');
  localStorage.setItem('plate', p);
}

// return the tour open from the local storage
export const getTourOpen = () => {
  return localStorage.getItem('tourOpen') === 'false' ? false : true;
}

// update tour open.
export const setTourOpen = () => {
  localStorage.removeItem('tourOpen');
  localStorage.setItem('tourOpen', 'false');
}

// return the last phone and sms code
export const getLastSms = () => {
  return [localStorage.getItem('SMS_TEL') || '', localStorage.getItem('SMS_KOD') || ''];
}

// update tour open.
export const setLastSms = (tel, phone) => {
  localStorage.removeItem('SMS_TEL');
  localStorage.removeItem('SMS_KOD');
  localStorage.setItem('SMS_TEL', tel);
  localStorage.setItem('SMS_KOD', phone);
}


export const openBlob = (blob, fileName = 'ArtemisFile') => {

  const fileURL = window.URL.createObjectURL(blob);
  var a = document.createElement("a");
  document.body.appendChild(a);
  a.style = "display: none";
  a.href = fileURL;
  a.target = '_self';
  a.download = fileName;
  a.click();
  setTimeout(() => {
    window.URL.revokeObjectURL(fileURL);
  }, 5000);
}


export const generateCode2 = (length) => {
  var result = '';
  var characters = '0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export const generateCode = (length) => {
  const characters = '0123456789';
  const charactersLength = characters.length;

  const getRandomInt = (max) => {
    let randomBuffer = new Uint32Array(1);
    window.crypto.getRandomValues(randomBuffer);
    return Math.floor(randomBuffer[0] / (0xFFFFFFFF + 1) * max);
  };

  let result = '';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(getRandomInt(charactersLength));
  }
  return result;
};

export const handleLogout = () => {
  let user = getUser();
  if (user === undefined || user === null) {
    return;
  }
  removeUserSession();
  sessionStorage.clear();
  localStorage.clear();


};

export const handleLogoutMain = () => {
  const dataLogOut = {};
  const configLogOut = {
    headers: { 'Content-Type': 'application/json' }
  };
  axios.post('/DeleteToken', dataLogOut, configLogOut)
    .then(response => {
      handleLogout();
    }).catch(error => {
      handleLogout();
    });
}

export const getDifferenceInDays = (date1, date2) => {
  const diffInMs = Math.abs(date2 - date1);
  return diffInMs / (1000 * 60 * 60 * 24);
}
export const moneyFormat = (Price, CountryCode, Currency) =>
  new Intl.NumberFormat(CountryCode, {
    style: 'currency',
    currency: Currency,
    minimumFractionDigits: 2
  })
    .formatToParts(Price)
    .map(p => (p.type !== 'literal' && p.type !== 'currency' ? p.value : ''))
    .join('');

export const safeParseInt = (val) => {
  const parsed = parseInt(val, 10);
  return isNaN(parsed) ? 0 : parsed; // Eğer sayı değilse 0 gönder
};

export const safeRequestParam = (val) => {
  if (!val) return '0';

  let v = String(val)
    .toLowerCase('tr-TR')
    .replace(/[/.+&?#%]/g, '')
    .trim();

  // IIS / ASP.NET özel path’leri
  const forbidden = [
    'bin',
    'app_data',
    'appdata',
    'content',
    'wwwroot',
    'web.config',
    'global.asax'
  ];

  if (forbidden.includes(v)) {
    return '_' + v; // bin → _bin
  }

  return v || '0';
};

export const monthsTr = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];
